import { Table } from "antd";
import styled from "styled-components";

export const StyledTable = styled(Table)`

    .ant-table-row {
        &.is-featured {
            background-color: #fffcf1;
        }

        &.is-featured:hover, &.is-featured:focus {
            background-color: #fdf9e2 !important;
        }
    }


    .time--greyed {
        display: inline-block;
        margin-top: -3px;
        color: grey;
    }

`;
